import { UTTermsMd } from '@group-link-one/gl-ui/utilities';
import { useState } from 'react';
import { TermsContainer, Text, TextButton } from '../Login.styles';
import type { CustomLocale } from '../Types/Login.locale.types';

interface TermsSectionProps {
  customLocale: CustomLocale;
}

const PRIVACY_POLICY_URL =
  'https://cdn.grouplinkone.com/Utilities/Water/politica_privacidade_group_link_one.md';

const TermsSection = ({ customLocale }: TermsSectionProps) => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const handleOpenTerms = () => {
    setIsTermsOpen(true);
  };

  const handleCloseTerms = () => {
    setIsTermsOpen(false);
  };

  return (
    <>
      <div className={TermsContainer}>
        <div className={Text}>
          {/*
            Only the privacy policy has a URL, so the sentence names just that one. `terms.terms`
            stays in the locale for when a terms-of-service document exists.
          */}
          {customLocale('terms.message1')}
          <button className={TextButton} onClick={handleOpenTerms} type='button'>
            {customLocale('terms.privacy')}
          </button>
        </div>
      </div>
      <UTTermsMd url={PRIVACY_POLICY_URL} open={isTermsOpen} onClose={handleCloseTerms} />
    </>
  );
};

export { TermsSection };
export type { TermsSectionProps };
